import gql from 'graphql-tag';

export const FETCH_SUMMARY = gql`
  query find_meeting_summary($id: Int!) {
    student_milestone_exercises(where: {id: {_eq: $id}}) {
      id
      milestone_id
      status
      due_date
      meeting_attendees
      meeting_summary
    }
  }
`

export const FETCH_USER_BY_ID = gql`
  query find_user_by_id($id: Int!) {
    users(where: {user_id: {_eq: $id}}) {
      user_last_name
      user_first_name
      user_type
    }
  }
`